import { Instance, SnapshotOut, types } from 'mobx-state-tree';
import { withSetPropAction } from 'src/models/extensions/withSetPropAction';
import { OperatorInfo } from 'src/models/operator-info/OperatorInfo';

/**
 * # Materials
 *
 * Materials을 설명하세요.
 */
export const Materials = types
  .model('Materials')
  .props({
    materialSid: types.number,
    langCd: types.maybeNull(types.string),
    title: types.maybeNull(types.string),
    useYn: types.optional(types.boolean, true),
    delYn: types.optional(types.boolean, false),
    filePath: types.maybeNull(types.array(types.string)),
    regUser: types.maybeNull(OperatorInfo),
    updUser: types.maybeNull(OperatorInfo),
    regDt: types.optional(types.maybeNull(types.number), 0),
    updDt: types.optional(types.maybeNull(types.number), 0),
  })
  .volatile(() => ({
    files: types.maybeNull(types.array(types.frozen())),
  }))
  .actions(withSetPropAction);

// --------------------------------------------------------------------------
type TMaterials = Instance<typeof Materials>;
type TMaterialsSnapshot = SnapshotOut<typeof Materials>;

export interface IMaterials extends TMaterials {}
export type TMaterialsKeys = keyof TMaterialsSnapshot & string;
export interface IMaterialsSnapshot extends TMaterialsSnapshot {}
export const createMaterials = () => types.optional(Materials, {} as TMaterials);
